<template>
  <div>
    <slot name="group:title"></slot>
    <div :class="computedGrid">
      <component
        v-for="c in components"
        :key="c.key"
        :is="c.name"
        :controls="controls"
        :value="c.value"
        :http-errors="c.errors"
        :grid="grid"
        @input:field="onInput($event, c.key)"
      ></component>
    </div>
  </div>
</template>

<script>
import FieldSchedulingFor from "@/components/Field/Filter/SchedulingFor.vue";
import FieldGuardianFirstName from "@/components/Field/Filter/GuardianFirstName.vue";
import FieldGuardianLastName from "@/components/Field/Filter/GuardianLastName.vue";
import FieldGuardianEmail from "@/components/Field/Filter/GuardianEmail.vue";
import FieldGuardianMobilePhone from "@/components/Field/Filter/GuardianMobilePhone.vue";
import FieldSubheader from "@/components/Field/Filter/Subheader.vue";

export default {
  components: {
    FieldSchedulingFor,
    FieldSubheader,
    FieldGuardianFirstName,
    FieldGuardianLastName,
    FieldGuardianEmail,
    FieldGuardianMobilePhone,
  },
  props: ["controls", "errors", "grid"],
  computed: {
    computedGrid() {
      if (!this.grid) return "grid grid-cols-1 gap-4 sm:grid-cols-2";
      if (this.grid === "cols-1") return "grid grid-cols-1 gap-4";
      return this.grid;
    },
    isAscend() {
      return this.controls?.locations?.software === "dentrixascend";
    },
    isReverse() {
      return this.$store.getters.flowType === "reverse";
    },
    isSingle() {
      return this.$store.getters.isSingleLocation;
    },
    hasLocation() {
      return this.controls?.locations;
    },
    isSchedulingForSomeoneElse() {
      return this.controls?.scheduling_for === "someone-else";
    },
    fields() {
      return this.isSchedulingForSomeoneElse
        ? [
            "subheader",
            "scheduling_for",
            "guardian_first_name",
            "guardian_last_name",
            "guardian_email",
            "guardian_mobile_phone",
          ]
        : ["subheader", "scheduling_for"];
    },
    components() {
      return this.fields.map((el) => ({
        key: el,
        name: "field-" + el.replace(/_/g, "-"),
        value: this.controls[el],
        errors: this.errors?.validation?.[`input.${el}`],
      }));
    },
  },
  watch: {
    "controls.patient_type": {
      handler(val, oldVal) {
        if (oldVal !== undefined && val !== oldVal) {
          this.onInput(null, "services");
        }
      },
    },
    "controls.age_type": {
      handler(val, oldVal) {
        if (oldVal !== undefined && val !== oldVal) {
          this.onInput(null, "services");
        }
      },
    },
  },
  methods: {
    onInput(value, key) {
      this.$emit("input:group", { value, key });
    },
  },
};
</script>
